import { useEffect, useState } from "react";
import useFormStore from "../../store/formData";
import TabInput from "../TabInput/TabInput";

const TabInputConatiner = (props) => {
  const { formData, setFormData } = useFormStore();
  const [checked, setChecked] = useState(0);
  const [attributes, setAttributes] = useState(
    props.data.options && props.data.options[0].attributes,
  );

  useEffect(() => {
    formData[props.data.id]
      ? props.data.options &&
        props.data.options.map((item, index) => {
          if (formData[props.data.id] === item.id) {
            setChecked(index);
            setAttributes(item.attributes);
          }
        })
      : setFormData(
          props.data.id,
          props.data.options && props.data.options[0].id,
        );
  }, []);

  function tabClickHandler(index, id) {
    setChecked(index);
    setAttributes(props.data.options && props?.data.options[index].attributes);
    setFormData(props.data.id, id);
  }
  return (
    <TabInput
      options={props.data.options || []}
      name={props.data.name}
      id={props.data.id}
      checked={checked}
      attributes={attributes}
      tabClickHandler={tabClickHandler}
    />
  );
};

export default TabInputConatiner;
